import React from 'react';
import AsyncPage from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default [
  <BlankLayout
    key="/perfectbeauty/youcam/privacy-policy-api"
    exact
    path="/perfectbeauty/youcam/privacy-policy-api"
    component={AsyncPage}
  />,
];
